import { BlueprintInstanceType } from '@rta/rta-blueprint-library';
import { type ContextData } from '../types/context-data.type';

export const emptyContextData = (): ContextData => {
	return {
		menuKey: BlueprintInstanceType.NoOp,
		element: null,
		id: null,
		center: { x: 0, y: 0 }
	};
};
